import React from 'react';

const FlechaDerecha = (props) => (
  <svg fill="none" viewBox="0 0 17 39" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path 
      d="m15.819 17.189c0.6731 1.2067 0.6868 2.6727 0.0364 3.8917l-8.125 15.227c-1.0562 1.9795-3.5172 2.728-5.4967 1.6717-1.9795-1.0562-2.7279-3.5172-1.6717-5.4967l7.0814-13.271-7.0451-12.629c-1.093-1.9594-0.39074-4.4339 1.5687-5.527 1.9594-1.0931 4.4339-0.39074 5.527 1.5687l8.125 14.565z" 
      clipRule="evenodd" 
      fill="#fff" 
      fillRule="evenodd"
    />
  </svg>
);

export default FlechaDerecha;